import { CategoryID } from '@sbt-web/network/types';
import { getCategoryByID } from '@sbt-web/category-utils';

const Motori = getCategoryByID(CategoryID.Motori);
const Elettronica = getCategoryByID(CategoryID.Elettronica);
const CasaPersona = getCategoryByID(CategoryID.CasaPersona);
const SportsHobby = getCategoryByID(CategoryID.SportsHobby);
const Immobili = getCategoryByID(CategoryID.Immobili);
const Lavoro = getCategoryByID(CategoryID.LavoroServizi);
const ImmobiliDefault = { label: 'Tutto immobili', id: CategoryID.Immobili };
const CategoriesImmobili = [
    ...Immobili.categories,
    ImmobiliDefault,
];
const MotoriDefault = { label: 'Tutto motori', id: CategoryID.Motori };
const CategoriesMotori = [
    ...Motori.categories,
    MotoriDefault,
];
const LavoroDefault = { label: 'Tutto lavoro', id: CategoryID.LavoroServizi };
const CategoriesLavoro = [
    ...Lavoro.categories,
    LavoroDefault,
];
const MarketDefault = { label: 'Tutte le categorie', id: CategoryID.Tutte };
const CategoriesMarket = [
    MarketDefault,
    {
        label: 'Elettronica',
        id: CategoryID.Elettronica,
        categories: Elettronica?.categories ?? [],
    },
    {
        label: 'Per la casa e la persona',
        id: CategoryID.CasaPersona,
        categories: CasaPersona?.categories ?? [],
    },
    {
        label: 'Sports e hobby',
        id: CategoryID.SportsHobby,
        categories: SportsHobby?.categories ?? [],
    },
    { label: 'Altri', id: CategoryID.AltriAnnunci, categories: [] },
];
const Verticals = {
    Motori: {
        categories: CategoriesMotori,
        key: 'motori',
        label: 'Motori',
        default: MotoriDefault,
    },
    Market: {
        categories: CategoriesMarket,
        key: 'market',
        label: 'Market',
        default: MarketDefault,
    },
    Immobili: {
        categories: CategoriesImmobili,
        key: 'immobili',
        label: 'Immobili',
        default: ImmobiliDefault,
    },
    Lavoro: {
        categories: CategoriesLavoro,
        key: 'lavoro',
        label: 'Lavoro',
        default: LavoroDefault,
    },
};

export { Verticals };
//# sourceMappingURL=categories.js.map
